import React, { useEffect, useRef } from 'react';
import { useAuthWizardContext } from 'providers/AuthWizardProvider';
import PropTypes from 'prop-types';
import { Button, Card, Space, Typography } from 'antd';
import { CheckCircleOutlined, PlusOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Success = ({ reset, onSubmit }) => {
  const { setStep, setUser } = useAuthWizardContext();
  const hasSubmitted = useRef(false);

  useEffect(() => {
    if (onSubmit && !hasSubmitted.current) {
      hasSubmitted.current = true;
      onSubmit();
    }
  }, [onSubmit]);

  const emptyData = () => {
    setStep(1);
    setUser({});
    reset();
  };

  return (
    <Card
      style={{ borderRadius: 12, textAlign: 'center', border: '1px solid #e6f4ea' }}
    >
      <Space direction="vertical" size={10} style={{ width: '100%' }}>
        <CheckCircleOutlined style={{ fontSize: 34, color: '#52c41a' }} />

        <Title level={4} style={{ marginBottom: 0 }}>
          User profile is all set
        </Title>

        <Text type="secondary">That user is ready to access their account.</Text>

        <div>
          <Button type="primary" icon={<PlusOutlined />} onClick={emptyData}>
            Sign Up Another
          </Button>
        </div>
      </Space>
    </Card>
  );
};

Success.propTypes = {
  reset: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
};

export default Success;
